import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

document.querySelectorAll('.element-timeline').forEach((el) => {
  if (window.matchMedia('(max-width: 767px)').matches) {
    return
  }

  const image = el.querySelector('.timeline-image')

  el.querySelectorAll('.timeline-item').forEach((item) => {
    ScrollTrigger.create({
      trigger: item,
      markers: false,
      start: () => {
        const announcementHeight = parseInt(
          getComputedStyle(document.documentElement).getPropertyValue('--site-announcement-height')
        )
        const headerHeight = parseInt(
          getComputedStyle(document.documentElement).getPropertyValue('--site-header-height')
        )

        const offset = Math.ceil(announcementHeight + headerHeight + window.innerWidth * 0.25)

        return `top ${offset}`
      },
      onEnter: () => {
        const index = item.dataset.index

        image.querySelectorAll(`[data-image-index]`).forEach((x) => x.classList.remove('is-active'))
        image.querySelector(`[data-image-index="${index}"`).classList.add('is-active')
      },
      onLeaveBack: () => {
        const index = parseInt(item.dataset.index)

        if (index !== 1) {
          image.querySelector(`[data-image-index="${index - 1}"`).classList.add('is-active')
          image.querySelector(`[data-image-index="${index}"`).classList.remove('is-active')
        }
      },
    })
  })
})
